var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 4.00016H25.3346V1.3335H22.668V4.00016H9.33463V1.3335H6.66797V4.00016H5.33464C3.86797 4.00016 2.66797 5.20016 2.66797 6.66683V28.0002C2.66797 29.4668 3.86797 30.6668 5.33464 30.6668H26.668C28.1346 30.6668 29.3346 29.4668 29.3346 28.0002V6.66683C29.3346 5.20016 28.1346 4.00016 26.668 4.00016ZM26.668 28.0002H5.33464V10.6668H26.668V28.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.be1c7a8ad7f45d3e86d11bb03ae66c77.svg";
export { ForwardRef as ReactComponent };